import { useCallback } from 'react';
import {
  readPatientImageCacheEntry,
  writePatientImageCacheEntry,
  getPatientImageWithCache,
} from '../utils/patientImageCache';

/**
 * Hook para cache de imagens de paciente (memória + localStorage).
 * Reutilizável entre Pacientes e PacientesBeta.
 */
export const usePatientImageCache = () => {
  const readCacheEntry = useCallback((pacienteId) => readPatientImageCacheEntry(pacienteId), []);

  const writeCacheEntry = useCallback(
    (pacienteId, url) => writePatientImageCacheEntry(pacienteId, url),
    []
  );

  const getImageWithCache = useCallback(
    (pacienteId) => getPatientImageWithCache(pacienteId),
    []
  );

  return { readCacheEntry, writeCacheEntry, getImageWithCache };
};
